import axios from "axios";

export const PERSONNEL_TYPE_URL = "/PersonnelType";
export const STUDENT_REPORT_URL = "/StudentReport";

/** Belli Bir Öğrenci Kayıt İptal Raporunu Elde Eder */
export function getRegistrationCancellationReport(queryParams) {
  return axios.post(`${STUDENT_REPORT_URL}/GetRegistrationCancellationReport`, queryParams);
}

/** Belli Bir Öğrenci Kayıt İptal Raporunu Sayfalama Olmadan Elde Eder */
export function getAllRegistrationCancellationReport(queryParams) {
  return axios.post(`${STUDENT_REPORT_URL}/GetAllRegistrationCancellationReport`, queryParams);
}

/** Belli Bir Öğrenci Raporunu Elde Eder */
export function getStudentReport(queryParams) {
  return axios.post(`${STUDENT_REPORT_URL}/GetStudentReport`, queryParams);
}

/** Mevcut Okulun Personel Türü Listesini Öğretmen İle Beraber Elde Eder */
export function getPersonnelTypes() {
  return axios.get(`${PERSONNEL_TYPE_URL}/GetPersonnelTypesWithTeacher`);
}

/** Belli Bir Öğrenci Listesinin Belli Bir Dönemdeki Kayıtlarını Aktif Eder */
export function activateRegistrations(term, entityId) {
  return axios.post(`${STUDENT_REPORT_URL}/ActivateRegistrations`, { term, entityId });
}

/** Belli Bir Öğrenci Listesini Siler */
export function deleteStudents(ids) {
  return axios.post(`${STUDENT_REPORT_URL}/Delete`, { ids });
}